import { Alert, Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import modalStyles from '../../styles/modals.module.css'

interface DeleteConfirmModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  header?: string
  body?: string
  cancelLabel?: string
  confirmLabel?: string
  isLoading?: boolean
  error?: string
  backdropClassName?: string
  className?: string
}

const DeleteConfirmModal = ({
  show,
  onHide,
  onConfirm,
  header,
  body,
  cancelLabel,
  confirmLabel,
  isLoading = false,
  error,
  backdropClassName,
  className
}: DeleteConfirmModalProps) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={!isLoading}
      fullscreen="sm-down"
      className={`${modalStyles.xenGolfModal}${className ? ' ' + className : ''}`}
      contentClassName={modalStyles.xenGolfModalContent}
      backdropClassName={backdropClassName}
    >
      <Modal.Header closeButton={!isLoading} className={modalStyles.xenGolfModalHeader}>
        <Modal.Title className={modalStyles.xenGolfModalTitle}>
          {header || t('confirm.delete.header')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={modalStyles.xenGolfModalBody}>
        <div className="mb-0" style={{ whiteSpace: 'pre-line' }}>
          {body || t('confirm.delete.body')}
        </div>
        {error && <Alert variant="danger" className="mt-3 mb-0">{error}</Alert>}
      </Modal.Body>

      <Modal.Footer className={`${modalStyles.xenGolfModalFooter} d-flex gap-2`}>
        <Button
          variant="warning"
          onClick={onHide}
          disabled={isLoading}
          className="flex-fill"
          data-testid="confirm-modal-cancel"
        >
          {cancelLabel || t('common:actions.cancel')}
        </Button>
        <Button
          variant="danger"
          onClick={handleConfirm}
          disabled={isLoading}
          className="flex-fill"
          data-testid="confirm-modal-confirm"
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
              {t('common:status.processing')}
            </>
          ) : (
            confirmLabel || t('common:actions.delete')
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteConfirmModal
